import { pricingConstants } from '../constants';

export function pricing(state = {}, action) {
  switch (action.type) {
    case pricingConstants.GET_PRICING_REQUEST:
      return {
        loading: true
      };
    case pricingConstants.GET_PRICING_SUCCESS:
      return {
        ...state, tariff: action.data
      };
    case pricingConstants.GET_PRICING_FAILURE:
      return {
        error: action.error
      };
    case pricingConstants.GET_PRICING_ALL_REQUEST:
      return {
        loading: true
      };
    case pricingConstants.GET_PRICING_ALL_SUCCESS:
      return {
        ...state, tariffs: action.data
      }
    case pricingConstants.GET_PRICING_ALL_FAILURE:
      return {
        error: action.error
      };
    case pricingConstants.UPDATE_PRICING_REQUEST:
      return {
        loading: true
      };
    case pricingConstants.UPDATE_PRICING_SUCCESS:
      return {
        ...state
      };
    case pricingConstants.UPDATE_PRICING_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
